/**
 * Texte der Oberfläche, Deutsch. Dies ist die Quelle: Jeder Schlüssel hier
 * muss in jeder anderen Sprache stehen (Typ `Texte`). Platzhalter `{name}`.
 * Schlüssel und Wortlaut des Anmeldeschirms wie im Portal (Post #5421).
 */
export const de = {
  'anmeldung.untertitel': 'Content',
  'anmeldung.email.zeigen': 'Login mit Email + Passwort',
  'anmeldung.email.verbergen': 'Email-Login verbergen',
  'anmeldung.email.platzhalter': 'email@example.com',
  'anmeldung.passwort.platzhalter': 'Passwort',
  'anmeldung.absenden': 'Anmelden',
  'anmeldung.laeuft': 'Login…',
  'anmeldung.fehlgeschlagen': 'Login fehlgeschlagen',
  'anmeldung.mit': 'Mit {anbieter} anmelden',
  'anmeldung.keinWeg': 'Auf dieser Instanz ist kein Anmeldeweg eingerichtet. Bitte wende dich an die Person, die sie betreibt.',
  'anmeldung.vorbereiten': 'Anmeldung wird vorbereitet …',
  'anmeldung.verarbeiten': 'Anmeldung wird verarbeitet …',
  'anmeldung.zurueck': 'Zurück zur Anmeldung',
  'anmeldung.konto': 'Konto anlegen',
} as const

export type TextSchluessel = keyof typeof de
export type Texte = Record<TextSchluessel, string>
